import { SlatePluginOptions } from '@udecode/slate-plugins-core';

export const ELEMENT_TODO_LI = 'action_item';

export const DEFAULTS_TODO_LIST: Partial<SlatePluginOptions> = {
  hotkey: ['mod+opt+4', 'mod+shift+4'],
};
